import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type {
  UsersAllRolesSchema,
  UsersUserSchemaWithIdNullable,
} from '@iconik-io/iconik-api/src/services/users';

import type { AuthState, RolesDictionary } from './types';

const initialState: AuthState = {
  userRoles: undefined,
  rawRoles: undefined,
  currentUser: undefined,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCurrentUser: (
      state,
      action: PayloadAction<UsersUserSchemaWithIdNullable>,
    ) => {
      state.currentUser = action.payload;
    },
    setUserRoles: (state, action: PayloadAction<RolesDictionary>) => {
      state.userRoles = action.payload;
    },

    setRawRoles: (state, action: PayloadAction<UsersAllRolesSchema>) => {
      state.rawRoles = action.payload;
    },
  },
});

export const { setCurrentUser, setUserRoles, setRawRoles } = authSlice.actions;

export const authReducer = authSlice.reducer;
